import { GetStaticProps, NextPage } from 'next'
import { TermsList } from 'web_core/assets/term/List'
import {
  TermWithGlossaryInfo,
  getDocs,
  glossaryTermsCollectionRef,
} from 'web_core/firebase'
import { sortTermsWithGlossaryInfo } from 'web_core/models/glossary'
import { addLocaleProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { useLayoutProperty } from '~/context/layout_property'

type Props = {
  terms: TermWithGlossaryInfo[]
}

export const getStaticProps: GetStaticProps<Props> = async ({
  locale = 'ja',
}) => {
  // 全用語解説を読み込むので、クライアントでは取り直さず、ISRの間隔も長めにとる
  const snapshot = await getDocs(glossaryTermsCollectionRef)
  const result = {
    props: {
      terms: sortTermsWithGlossaryInfo(snapshot.docs.map((doc) => doc.data())),
    },
    revalidate: 600,
  }
  return addLocaleProps(result, locale)
}

const Page: NextPage<Props> = ({ terms }) => {
  const { headerHeight, mobileCategoriesMenuHeight } = useLayoutProperty()
  return (
    <DefaultLayout
      head={{
        title: '大学数学の用語の一覧',
        description:
          '本ページでは現代数学の用語の一覧を五十音順で掲載しています。各用語の解説も充実しています。大学数学や現代数学を学んでいる人必見です。',
      }}
      categoriesMenu={{ pc: true, sp: true, spFixed: true }}
      leftSidebar
      rightSideBar
    >
      <div className="mathdown-monotone">
        <h1>現代数学の用語の一覧</h1>
        <TermsList
          terms={terms}
          scrollMarginTop={headerHeight + mobileCategoriesMenuHeight + 16}
        />
      </div>
    </DefaultLayout>
  )
}

export default Page
